import { FInter, FlexBox, useBreakpoint, useToasts } from "@brg/ui"
import { useModal } from "core"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "shared/components/buttons"
import styled, { useTheme } from "styled-components"

/**
 * @param Модалка для несохраненных данных @Artem
 */

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`

const ModalButtonHollow = styled(RectangularButtonHollow)`
  max-width: 342px;
  min-width: 282px;
  padding: 12px 15px;
  height: 46px !important;
  margin-right: 0;
  line-height: 22px !important;
  font-size: 17px !important;
  @media (max-width: 743px) {
    width: 100% !important;
    min-width: 100%;
    height: 38px !important;
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

const ModalButtonFilled = styled(RectangularButtonFilled)`
  width: 342px;
  min-width: 342px;
  padding: 12px 15px;
  height: 46px !important;
  margin-right: 0;
  line-height: 22px !important;
  font-size: 17px !important;
  @media (max-width: 743px) {
    min-width: 100%;
    width: 100% !important;
    height: 38px !important;
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

const Wrapper = styled(FlexBox)`
  width: auto;
  padding: 32px 40px 40px;
  border-radius: 8px;
  gap: 16px;
  background: ${({ theme }) => theme.mainBg};
  margin-bottom: 20%;
  max-width: 648px;
  align-items: start;

  @media (max-width: 743px) {
    padding: 40px 10px;
    gap: 8px;
  }
`

const Title = styled(FInter.SectionTitle)`
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.6px;
  line-height: 33px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 743px) {
    font-size: 22px;
    line-height: 28px;
  }
`

const Text = styled(FInter.Text)`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 743px) {
    font-size: 13px;
    line-height: 16px;
  }
`

const ButtonsWrapper = styled(FlexBox)`
  margin-top: 16px;
  width: 100%;
  justify-content: center;
`

export const NotSavedDataModal: FC<{
  path: string
  callback: (s: boolean) => void
  msgText?: string
  title?: string
  buttonNames?: any
}> = ({ path, callback, msgText, title, buttonNames }) => {
  const { t } = useTranslation()
  const { error } = useToasts()
  const theme = useTheme()
  const modal = useModal()
  const isMobile = useBreakpoint(743)

  return (
    <Wrapper
      className="notSavedModal_wrapper"
      direction={"column"}
      width={"100%"}
      justify="left"
      align="center"
    >
      <Title color={theme.not_saved_modal.title}>
        {title || t("not_saved_modal.title")}
      </Title>
      <Text color={theme.not_saved_modal.description}>
        {msgText || t("not_saved_modal.description")}
      </Text>
      <ButtonsWrapper
        direction="row"
        gx={16}
        gxMobile={isMobile ? 1 : 16}
        gyMobile={isMobile ? 8 : 1}
        directionMobile={isMobile ? "column" : "row"}
      >
        <ModalButtonHollow
          onClick={() => {
            modal.hide()
            callback(true)
            error(t("not_success_save"))
            setTimeout(() => {
              window.location.href = path
            }, 1000)
          }}
        >
          {buttonNames?.leave ||
            (isMobile
              ? t("not_saved_modal.exit_mob")
              : t("not_saved_modal.exit"))}
        </ModalButtonHollow>
        <ModalButtonFilled
          onClick={() => {
            modal.hide()
            callback(false)
          }}
        >
          {buttonNames?.stay ||
            (isMobile
              ? t("not_saved_modal.return_mob")
              : t("not_saved_modal.return"))}
        </ModalButtonFilled>
      </ButtonsWrapper>
    </Wrapper>
  )
}
import { FInter, FlexBox, useBreakpoint, useToasts } from "@brg/ui"
import { useModal } from "core"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "shared/components/buttons"
import styled, { useTheme } from "styled-components"

/**
 * @param Модалка для несохраненных данных @Artem
 */

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`

const ModalButtonHollow = styled(RectangularButtonHollow)`
  max-width: 342px;
  min-width: 282px;
  padding: 12px 15px;
  height: 46px !important;
  margin-right: 0;
  line-height: 22px !important;
  font-size: 17px !important;
  @media (max-width: 743px) {
    width: 100% !important;
    min-width: 100%;
    height: 38px !important;
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

const ModalButtonFilled = styled(RectangularButtonFilled)`
  width: 342px;
  min-width: 342px;
  padding: 12px 15px;
  height: 46px !important;
  margin-right: 0;
  line-height: 22px !important;
  font-size: 17px !important;
  @media (max-width: 743px) {
    min-width: 100%;
    width: 100% !important;
    height: 38px !important;
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

const Wrapper = styled(FlexBox)`
  width: auto;
  padding: 32px 40px 40px;
  border-radius: 8px;
  gap: 16px;
  background: ${({ theme }) => theme.mainBg};
  margin-bottom: 20%;
  max-width: 648px;
  align-items: start;

  @media (max-width: 743px) {
    padding: 40px 10px;
    gap: 8px;
  }
`

const Title = styled(FInter.SectionTitle)`
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.6px;
  line-height: 33px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 743px) {
    font-size: 22px;
    line-height: 28px;
  }
`

const Text = styled(FInter.Text)`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 743px) {
    font-size: 13px;
    line-height: 16px;
  }
`

const ButtonsWrapper = styled(FlexBox)`
  margin-top: 16px;
  width: 100%;
  justify-content: center;
`

export const NotSavedDataModal: FC<{
  path: string
  callback: (s: boolean) => void
  msgText?: string
  title?: string
  buttonNames?: any
}> = ({ path, callback, msgText, title, buttonNames }) => {
  const { t } = useTranslation()
  const { error } = useToasts()
  const theme = useTheme()
  const modal = useModal()
  const isMobile = useBreakpoint(743)

  return (
    <Wrapper
      className="notSavedModal_wrapper"
      direction={"column"}
      width={"100%"}
      justify="left"
      align="center"
    >
      <Title color={theme.not_saved_modal.title}>
        {title || t("not_saved_modal.title")}
      </Title>
      <Text color={theme.not_saved_modal.description}>
        {msgText || t("not_saved_modal.description")}
      </Text>
      <ButtonsWrapper
        direction="row"
        gx={16}
        gxMobile={isMobile ? 1 : 16}
        gyMobile={isMobile ? 8 : 1}
        directionMobile={isMobile ? "column" : "row"}
      >
        <ModalButtonHollow
          onClick={() => {
            modal.hide()
            callback(true)
            error(t("not_success_save"))
            setTimeout(() => {
              window.location.href = path
            }, 1000)
          }}
        >
          {buttonNames?.leave ||
            (isMobile
              ? t("not_saved_modal.exit_mob")
              : t("not_saved_modal.exit"))}
        </ModalButtonHollow>
        <ModalButtonFilled
          onClick={() => {
            modal.hide()
            callback(false)
          }}
        >
          {buttonNames?.stay ||
            (isMobile
              ? t("not_saved_modal.return_mob")
              : t("not_saved_modal.return"))}
        </ModalButtonFilled>
      </ButtonsWrapper>
    </Wrapper>
  )
}
